import vBulletin from './vBulletin';

export default {
  vBulletin,
};
